import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getSessionTag, updateSessionTag } from '@api/sessionTag';
import { message } from 'antd';
import type { AxiosError } from 'axios';

// --- constants ---
const SESSION_QUERY_KEY = ['get-session-tag', 'ei'];
const STALE_TIME = 5 * 60 * 1000; // 5 min
const LOADING_KEY = 'SessionLoadingMessage';
const MESSAGE_DURATION = 2;
const CLEANUP_DELAY = 5000;

// --- hooks ---
export const useSessionList = (ssdType: string) =>
  useQuery([SESSION_QUERY_KEY, ssdType], () => getSessionTag(ssdType), {
    retry: 3,
    refetchOnWindowFocus: false,
    staleTime: STALE_TIME,
  });

export const useUpdateSession = () => {
  const queryClient = useQueryClient();

  return useMutation(updateSessionTag, {
    onMutate: () => {
      message.loading({
        content: 'Action in progress...',
        key: LOADING_KEY,
        duration: 0,
      });
    },
    onSuccess: (data, variables) => {
      message.success({ content: data.message, duration: MESSAGE_DURATION, key: LOADING_KEY });
      queryClient.invalidateQueries([SESSION_QUERY_KEY, variables.ssdType]);
    },
    onError: (error: AxiosError) => {
      const errorMessage =
        (error.response?.data as any)?.message || error.message || 'Something went wrong';
      message.error({ content: errorMessage, duration: MESSAGE_DURATION, key: LOADING_KEY });
    },
    onSettled: () => {
      setTimeout(() => message.destroy(LOADING_KEY), CLEANUP_DELAY);
    },
  });
};
